import { styled } from '@mui/material/styles';
import {
    Paper,
    InputBase,
    Box,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';

const Search = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.search.main,
    borderRadius: "10px",
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '400px',
    height: '48px',
    transition: 'width 0.3s ease-in-out',
}));

const SearchIconWrapper = styled(Box)(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.secondary.main
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: '#90909A',
    width: '100%',
    fontWeight: 400,
    fontSize: '14px',
    '& .MuiInputBase-input': {
        paddingLeft: `calc(1em + ${theme.spacing(5)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        '&:focus': { width: '100%' }
    }
}));

const SearchBar = ({ value, onChange }) => {
    const { t } = useTranslation();
    return (
        <Box sx={{ flexGrow: 1 }}>
            <Search>
                <SearchIconWrapper>
                    <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                    placeholder={t('header.search')}
                    inputProps={{ 'aria-label': 'search' }}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                />
            </Search>
        </Box>
    );
};

export default SearchBar;